import React from "react";
import { Accordion, Card, Col, Container, Row } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";

const Explanation: React.FC<{ explanationKeys: string[] }> = ({
  explanationKeys,
}): React.ReactElement => {
  const { t } = useTranslation();

  const isDefined = (key: string) => t(key) !== key;

  return (
    <div className="explanation-container pb-4">
      {explanationKeys.map((explanationKey: string) => (
        <Container className="content-container" key={explanationKey}>
          {isDefined(`${explanationKey}.title`) && (
            <Row>
              <Col className="pt-0 pb-2">
                <CollapsibleAccordion titleKey={`${explanationKey}.title`}>
                  <Trans
                    i18nKey={`${explanationKey}.body`}
                    components={{
                      ul: <ul></ul>,
                      li: <li></li>,
                      b: <b></b>,
                      h2: <h2>heading2</h2>,
                      Link1: (
                        <a
                          href={t(`${explanationKey}.url1`)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://example.com/1
                        </a>
                      ),
                      Link2: (
                        <a
                          href={t(`${explanationKey}.url2`)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://example.com/2
                        </a>
                      ),
                      Link3: (
                        <a
                          href={t(`${explanationKey}.url3`)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://example.com/3
                        </a>
                      ),
                      Link4: (
                        <a
                          href={t(`${explanationKey}.url4`)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://example.com/4
                        </a>
                      ),
                    }}
                  />
                </CollapsibleAccordion>
              </Col>
            </Row>
          )}
        </Container>
      ))}
    </div>
  );
};

interface CollapsibleAccordionProps {
  titleKey: string;
  children: React.ReactNode;
}

const CollapsibleAccordion = ({
  titleKey,
  children,
}: CollapsibleAccordionProps): React.ReactElement => {
  const { t } = useTranslation();

  const title = t(titleKey);
  const titleLocalized = !!title;
  if (!titleLocalized) {
    return (
      <Card>
        <Card.Body>{children}</Card.Body>
      </Card>
    );
  }
  return (
    <Accordion>
      <Accordion.Item eventKey="0">
        <Accordion.Header>{t(titleKey)}</Accordion.Header>
        <Accordion.Body id={`${titleKey}-container`} role="region">
          {children}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default Explanation;
